import { useState, useEffect } from "react";
import { BrowserRouter, Routes, Route, Navigate, useNavigate, useLocation } from "react-router-dom";
import { FileText, TrendingUp, Calendar, Users, Lock, Settings, MessageCircle, MessageSquare, ChevronRight, LogOut, Check, AlertTriangle, Sparkles, X, Package, Gift, Zap, CreditCard, PlayCircle } from "lucide-react";
import AdminSuperPanel from "./pages/AdminSuperPanel";
import BotChatPanel from "./pages/BotChatPanel";
import ConfigCuenta from "./pages/ConfigCuenta";
import ControlFinanciero from "./pages/ControlFinanciero";
import Panol from './pages/Panol';
// import AvisoVersion from './components/AvisoVersion';   // apagado, ver abajo
import Personal from './pages/Personal';
import Planner from "./pages/Planner";
import Fiscal from "./pages/Fiscal";
import Gantt from "./cotizador/pages/Gantt";
import Maquinaria from "./cotizador/pages/Maquinaria";
import Menu from "./cotizador/pages/Menu";
import Clientes from "./pages/Clientes";
import Presupuesto from "./cotizador/pages/Presupuesto";
import Materiales from "./cotizador/pages/Materiales";
import ManoObra from "./cotizador/pages/ManoObra";
import AnalisisCostos from "./cotizador/pages/AnalisisCostos";
import Certificado from "./cotizador/pages/Certificado";
import CurvaInversion from "./cotizador/pages/CurvaInversion";
import ListadoMateriales from "./cotizador/pages/ListadoMateriales";
import ClientePortal from "./pages/ClientePortal";
import PersonalPortal from "./pages/PersonalPortal";
import AccesosClientes from "./pages/AccesosClientes";
import Landing from "./pages/Landing";
import Presentacion from "./pages/Presentacion";
import DemoPortal from "./pages/DemoPortal";
import Obra from "./pages/Obra";
import Mensajes from "./pages/Mensajes";
import DemoTour from "./components/DemoTour";
import RegistroTour from "./components/RegistroTour";
import ResumenDemo from "./cotizador/pages/ResumenDemo";
import Asistente from "./components/Asistente";
import Deshacer from "./components/Deshacer";
import ErrorBoundary from "./components/ErrorBoundary";
import api from "./cotizador/api";

const C = {
  bg:"#f8f9fa", surface:"#ffffff", surface2:"#f1f3f5",
  border:"#e0e0e8", border2:"#d0d0dc",
  text:"#1a1a2e", muted:"#6b7280",
  accent:"#059669", accent2:"#7c3aed", warn:"#d97706",
  green:"#10b981", red:"#ef4444", blue:"#3b82f6",
};

// ── Subscription wall ─────────────────────────────────────────────────────────
function SuscripcionVencida({ suscripcion, onLogout }) {
  const [loading, setLoading] = useState(false);
  const handlePagar = async () => {
    setLoading(true);
    try {
      const res = await api.post('/suscripcion/crear');
      const data = res.data;
      if (data.init_point) window.location.href = data.init_point;
      // El backend ya encontró una suscripción autorizada en MercadoPago: no hay
      // nada que pagar, solo hace falta recargar para entrar con el plan activo.
      else if (data.ya_suscripto) { alert("Tu suscripción ya está activa en MercadoPago. Recargamos la página."); window.location.reload(); }
      else alert("Error al crear la suscripción. Contactá a soporte.");
    } catch (e) { alert(e.response?.data?.detail || "Error de conexión. Probá de nuevo o contactá a soporte."); }
    setLoading(false);
  };
  return (
    <div style={{ background: C.bg, height: "100dvh", display: "flex", alignItems: "center", justifyContent: "center", padding: 24, fontFamily: "'Syne', sans-serif" }}>
      <div style={{ width: "100%", maxWidth: 440, background: C.surface, border: "1px solid " + C.border, borderRadius: 16, padding: 40, boxShadow: "0 4px 24px rgba(0,0,0,0.06)", textAlign: "center" }}>
        <Lock size={36} strokeWidth={1} color={C.accent} style={{ marginBottom: 16 }} />
        <div style={{ fontSize: 24, fontWeight: 800, color: C.accent, letterSpacing: "-1px", marginBottom: 4 }}>FAIM OBRAS</div>
        <div style={{ fontSize: 12, color: C.muted, marginBottom: 28, fontFamily: "'IBM Plex Mono', monospace", letterSpacing: "2px" }}>ACTIVÁ TU SUSCRIPCIÓN</div>
        <div style={{ background: "#f0fdf4", border: "1px solid #bbf7d0", borderRadius: 10, padding: "16px 20px", marginBottom: 24 }}>
          <div style={{ fontSize: 28, fontWeight: 700, color: C.accent, fontFamily: "'IBM Plex Mono', monospace" }}>
            $ {(suscripcion?.precio_total || suscripcion?.precio_mensual || 57000).toLocaleString("es-AR")}
          </div>
          <div style={{ fontSize: 12, color: C.muted, marginTop: 2 }}>
            por mes · plan base 2 usuarios
            {suscripcion?.usuarios_extra > 0 && ` + ${suscripcion.usuarios_extra} adicional${suscripcion.usuarios_extra > 1 ? "es" : ""}`}
          </div>
          {suscripcion?.usuarios_extra > 0 && (
            <div style={{ fontSize: 11, color: C.muted, marginTop: 4 }}>
              $ {(suscripcion.precio_mensual || 57000).toLocaleString("es-AR")} base + $ {((suscripcion.precio_usuario_extra || 7000) * suscripcion.usuarios_extra).toLocaleString("es-AR")} usuarios adicionales
            </div>
          )}
        </div>
        <div style={{ textAlign: "left", marginBottom: 24 }}>
          {["Cotizador completo con catálogo actualizado", "Certificados y control de avance", "Panel financiero y Gantt", "Múltiples presupuestos y clientes"].map(f => (
            <div key={f} style={{ display: "flex", alignItems: "center", gap: 8, fontSize: 13, color: C.text, marginBottom: 8 }}>
              <Check size={13} strokeWidth={2.5} color={C.accent} /> {f}
            </div>
          ))}
        </div>
        <button onClick={handlePagar} disabled={loading} className="btn btn-primary" style={{ width: "100%", padding: 12, justifyContent: "center", fontSize: 15, marginBottom: 10, background: loading ? C.border : C.accent2, opacity: loading ? 0.7 : 1 }}>
          {loading ? "Procesando..." : "Suscribirme con MercadoPago"}
        </button>
        <button onClick={onLogout} style={{ background: "none", border: "none", color: C.muted, cursor: "pointer", fontSize: 12, fontFamily: "'Syne', sans-serif" }}>
          Cerrar sesión
        </button>
      </div>
    </div>
  );
}

// ── Pantalla comercial post-registro ────────────────────────────────────────
// Es la pantalla que convierte: se muestra UNA vez, apenas se crea la cuenta,
// antes de entrar al sistema. Nada de reuniones acá — esa oferta se sacó del
// flujo (ver prompt.py del bot). No hay trial en el auto-registro (el tenant
// arranca en "vencido"), así que no hay a dónde "probar primero": quien no
// paga ahora, cierra sesión y vuelve cuando quiera. La agenda de la reunión
// de tutoría aparece después, cuando ya pagó (ver AvisoAgendarReunion).
const WHATSAPP_COMPROBANTES = "5493625548783"; // mismo numero configurado en el bot (ADMIN_WHATSAPP_NUMBER)

function PantallaVentaPostRegistro({ tenant, token, onContinuar, onLogout }) {
  const [vista, setVista] = useState("inicio"); // inicio | transferencia
  const [loading, setLoading] = useState(false);
  const precioBase = tenant?.precio_mensual || 57000;
  const precioPromo = Math.round(precioBase * (35000 / 57000) / 10) * 10; // mismo precio promo que whatsapp_bot/config.PROMO_PRECIO

  const suscribirse = async () => {
    setLoading(true);
    try {
      const res = await api.post('/suscripcion/crear?promo=true', {}, { headers: { Authorization: `Bearer ${token}` } });
      const data = res.data;
      if (data.init_point) window.location.href = data.init_point;
      else if (data.ya_suscripto) onContinuar();
      else alert("No se pudo generar el link de pago. Probá de nuevo o escribinos.");
    } catch { alert("Error de conexión. Probá de nuevo o escribinos por WhatsApp."); }
    setLoading(false);
  };

  const bonus = [
    "Portal del cliente sin cargo, con tu logo y tus colores",
    "Planner con sincronización a Google Calendar",
    "Control financiero semanal, quincenal o mensual",
    "Certificados de avance ilimitados",
  ];

  return (
    <div style={{ background: "linear-gradient(160deg, #0f1f18 0%, #16211c 55%, #0f1f18 100%)", minHeight: "100dvh", display: "flex", alignItems: "center", justifyContent: "center", padding: "32px 16px", fontFamily: "'Syne', sans-serif" }}>
      <style>{`
        @keyframes faimPulse { 0%,100% { transform: scale(1); } 50% { transform: scale(1.035); } }
        @keyframes faimFloat { 0%,100% { transform: translateY(0); } 50% { transform: translateY(-6px); } }
        @keyframes faimGlow { 0%,100% { box-shadow: 0 0 0 0 rgba(16,185,129,0.35); } 50% { box-shadow: 0 0 0 14px rgba(16,185,129,0); } }
      `}</style>
      <div style={{ width: "100%", maxWidth: 480, background: "#ffffff", borderRadius: 20, padding: "clamp(24px,5vw,40px)", boxShadow: "0 20px 60px rgba(0,0,0,0.35)", position: "relative", overflow: "hidden" }}>

        <div style={{ textAlign: "center", marginBottom: 22 }}>
          <div style={{ fontSize: 22, fontWeight: 800, color: C.accent, letterSpacing: "-1px" }}>FAIM OBRAS</div>
          <div style={{ fontSize: 14, color: C.muted, marginTop: 4 }}>¡Tu cuenta ya está lista{tenant?.nombre ? `, ${tenant.nombre}` : ""}!</div>
        </div>

        {vista === "inicio" ? (
          <>
            <div style={{ display: "inline-flex", alignItems: "center", gap: 6, background: C.red, color: "#fff", fontSize: 12, fontWeight: 800, padding: "6px 14px", borderRadius: 20, margin: "0 auto 18px", animation: "faimPulse 1.8s ease-in-out infinite" }}>
              <Zap size={13} strokeWidth={2.5} /> $ {precioPromo.toLocaleString("es-AR")}/MES LOS PRIMEROS 3 MESES · SOLO HOY
            </div>

            <div style={{ textAlign: "center", marginBottom: 20 }}>
              <div style={{ fontSize: 16, color: C.muted, textDecoration: "line-through", fontFamily: "'IBM Plex Mono', monospace" }}>
                $ {precioBase.toLocaleString("es-AR")} /mes
              </div>
              <div style={{ fontSize: 44, fontWeight: 800, color: C.accent, fontFamily: "'IBM Plex Mono', monospace", letterSpacing: "-1px", animation: "faimFloat 2.6s ease-in-out infinite" }}>
                $ {precioPromo.toLocaleString("es-AR")}
              </div>
              <div style={{ fontSize: 12, color: C.muted }}>tus primeros 3 meses con débito automático · después $ {precioBase.toLocaleString("es-AR")}/mes</div>
            </div>

            <div style={{ background: "#f0fdf4", border: "1px solid #bbf7d0", borderRadius: 12, padding: "14px 16px", marginBottom: 14 }}>
              <div style={{ display: "flex", alignItems: "center", gap: 8, fontSize: 13.5, fontWeight: 700, color: C.accent, marginBottom: 8 }}>
                <Check size={15} strokeWidth={2.5} /> Presupuestos ilimitados, desde el día uno
              </div>
            </div>

            <div style={{ border: `1px solid ${C.border}`, borderRadius: 12, padding: "14px 16px", marginBottom: 22 }}>
              <div style={{ display: "flex", alignItems: "center", gap: 6, fontSize: 11, fontWeight: 700, color: "#7c3aed", textTransform: "uppercase", letterSpacing: "0.5px", marginBottom: 10 }}>
                <Gift size={14} strokeWidth={2.5} /> Y de regalo, incluido
              </div>
              {bonus.map(b => (
                <div key={b} style={{ display: "flex", alignItems: "flex-start", gap: 8, fontSize: 13, color: C.text, marginBottom: 7 }}>
                  <Sparkles size={13} strokeWidth={2} color="#7c3aed" style={{ marginTop: 2, flexShrink: 0 }} /> {b}
                </div>
              ))}
            </div>

            <button onClick={suscribirse} disabled={loading} style={{ width: "100%", padding: 15, borderRadius: 12, border: "none", cursor: "pointer", background: C.accent, color: "#fff", fontFamily: "'Syne', sans-serif", fontWeight: 800, fontSize: 16, display: "flex", alignItems: "center", justifyContent: "center", gap: 8, opacity: loading ? 0.7 : 1, animation: loading ? "none" : "faimGlow 2.2s ease-in-out infinite", marginBottom: 10 }}>
              <CreditCard size={17} strokeWidth={2.5} /> {loading ? "Generando link..." : "Suscribirme ahora con débito automático"}
            </button>
            <button onClick={() => setVista("transferencia")} style={{ width: "100%", padding: 11, borderRadius: 12, border: `1px solid ${C.border}`, cursor: "pointer", background: "transparent", color: C.text, fontFamily: "'Syne', sans-serif", fontWeight: 600, fontSize: 13.5, marginBottom: 14 }}>
              Prefiero pagar por transferencia
            </button>
            <div style={{ textAlign: "center" }}>
              <button onClick={onLogout} style={{ background: "none", border: "none", color: C.muted, cursor: "pointer", fontSize: 12, fontFamily: "'Syne', sans-serif" }}>
                Cerrar sesión
              </button>
            </div>
          </>
        ) : (
          <>
            <div style={{ background: "#fffbeb", border: "1px solid #fde68a", borderRadius: 12, padding: "16px 18px", marginBottom: 18 }}>
              <div style={{ fontSize: 12, color: C.muted, marginBottom: 10 }}>Con el precio promo, solo tu primer mes (después $ {precioBase.toLocaleString("es-AR")}/mes):</div>
              <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", marginBottom: 8 }}>
                <span style={{ fontSize: 13, color: C.muted }}>Monto</span>
                <span style={{ fontSize: 18, fontWeight: 800, fontFamily: "'IBM Plex Mono', monospace" }}>$ {precioPromo.toLocaleString("es-AR")}</span>
              </div>
              <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}>
                <span style={{ fontSize: 13, color: C.muted }}>Alias</span>
                <span style={{ fontSize: 15, fontWeight: 800, color: C.accent, fontFamily: "'IBM Plex Mono', monospace" }}>Faimobras.app</span>
              </div>
            </div>
            <div style={{ fontSize: 13, color: C.text, lineHeight: 1.6, marginBottom: 18 }}>
              Hacé la transferencia y mandanos el comprobante por WhatsApp — en cuanto lo recibamos, te activamos la cuenta.
            </div>
            <a href={`https://wa.me/${WHATSAPP_COMPROBANTES}?text=${encodeURIComponent("Hola! Te mando el comprobante de la transferencia de FAIM OBRAS.")}`} target="_blank" rel="noreferrer"
              style={{ width: "100%", boxSizing: "border-box", padding: 15, borderRadius: 12, border: "none", cursor: "pointer", background: "#25D366", color: "#fff", fontFamily: "'Syne', sans-serif", fontWeight: 800, fontSize: 15, display: "flex", alignItems: "center", justifyContent: "center", gap: 8, marginBottom: 10, textDecoration: "none" }}>
              <MessageCircle size={17} strokeWidth={2.5} /> Mandar comprobante por WhatsApp
            </a>
            <button onClick={() => setVista("inicio")} style={{ width: "100%", padding: 11, borderRadius: 12, border: `1px solid ${C.border}`, cursor: "pointer", background: "transparent", color: C.text, fontFamily: "'Syne', sans-serif", fontWeight: 600, fontSize: 13.5, marginBottom: 14 }}>
              ← Volver a la suscripción automática
            </button>
            <div style={{ textAlign: "center" }}>
              <button onClick={onLogout} style={{ background: "none", border: "none", color: C.muted, cursor: "pointer", fontSize: 12, fontFamily: "'Syne', sans-serif" }}>
                Cerrar sesión
              </button>
            </div>
          </>
        )}
      </div>
    </div>
  );
}

// ── Aviso para agendar la reunión de tutoría (solo post-pago) ──────────────
function AvisoAgendarReunion({ token, onAgendada }) {
  const [loading, setLoading] = useState(null); // slot en curso, o null
  const [cerrado, setCerrado] = useState(false);
  if (cerrado) return null;

  const elegir = async (slot) => {
    setLoading(slot);
    try {
      await api.post('/suscripcion/agendar-reunion', { slot }, { headers: { Authorization: `Bearer ${token}` } });
      onAgendada(slot);
    } catch { alert("No se pudo agendar. Probá de nuevo."); }
    setLoading(null);
  };

  return (
    <div className="aviso-arriba" style={{ background: "#eef2ff", borderBottom: "1px solid #c7d2fe", padding: "10px 16px", display: "flex", alignItems: "center", justifyContent: "center", gap: 14, flexWrap: "wrap", fontFamily: "'Syne', sans-serif" }}>
      <span style={{ fontSize: 13, color: "#3730a3", display: "flex", alignItems: "center", gap: 6 }}>
        <Calendar size={14} strokeWidth={2.5} /> Coordinemos tu reunión de tutoría para arrancar con todo:
      </span>
      <button onClick={() => elegir("martes_manana")} disabled={!!loading} style={{ padding: "6px 12px", borderRadius: 8, border: "1px solid #c7d2fe", background: "#fff", color: "#3730a3", fontWeight: 700, fontSize: 12.5, cursor: "pointer" }}>
        {loading === "martes_manana" ? "..." : "Martes a la mañana"}
      </button>
      <button onClick={() => elegir("jueves_tarde")} disabled={!!loading} style={{ padding: "6px 12px", borderRadius: 8, border: "1px solid #c7d2fe", background: "#fff", color: "#3730a3", fontWeight: 700, fontSize: 12.5, cursor: "pointer" }}>
        {loading === "jueves_tarde" ? "..." : "Jueves a la tarde"}
      </button>
      <button onClick={() => setCerrado(true)} aria-label="Cerrar" style={{ background: "none", border: "none", cursor: "pointer", color: "#3730a3" }}>
        <X size={15} />
      </button>
    </div>
  );
}

// ── Trial banner ──────────────────────────────────────────────────────────────
function TrialBanner({ diasRestantes }) {
  if (diasRestantes > 7) return null;
  return (
    <div className="aviso-arriba" style={{ background: diasRestantes <= 2 ? "#fef2f2" : "#fffbeb", borderBottom: `1px solid ${diasRestantes <= 2 ? "#fecaca" : "#fde68a"}`, color: diasRestantes <= 2 ? C.red : C.warn, textAlign: "center", padding: "7px 16px", fontSize: 13, fontFamily: "'Syne', sans-serif" }}>
      <AlertTriangle size={13} strokeWidth={2} style={{ marginRight: 4, verticalAlign: "middle" }} /> Te {diasRestantes === 1 ? "queda" : "quedan"} <strong>{diasRestantes} día{diasRestantes !== 1 ? "s" : ""}</strong> de prueba gratuita.
      {diasRestantes <= 3 && " Suscribite para no perder el acceso."}
    </div>
  );
}

// ── Banner de anuncio global (lo publica el admin de plataforma) ───────────────
function AnuncioBanner({ anuncio, onClose }) {
  if (!anuncio) return null;
  return (
    <div className="aviso-arriba" style={{ background: "#eef2ff", borderBottom: "1px solid #c7d2fe", color: "#3730a3", padding: "8px 40px 8px 16px", fontSize: 13, fontFamily: "'Syne', sans-serif", position: "relative", textAlign: "center" }}>
      <Sparkles size={13} strokeWidth={2} style={{ marginRight: 6, verticalAlign: "middle" }} />
      {anuncio.titulo && <strong>{anuncio.titulo} </strong>}
      <span>{anuncio.mensaje}</span>
      <button onClick={onClose} aria-label="Cerrar" style={{ position: "absolute", right: 10, top: "50%", transform: "translateY(-50%)", background: "none", border: "none", cursor: "pointer", color: "#3730a3", lineHeight: 0 }}>
        <X size={16} />
      </button>
    </div>
  );
}

// ── Soporte técnico ──────────────────────────────────────────────────────────
function PaginaSoporte() {
  const MAIL = "contacto.faimobras@gmail.com";
  const WHATSAPP = "5493625305155";
  const WHATSAPP_MSG = encodeURIComponent("Hola, tengo una consulta sobre FAIM OBRAS.");

  return (
    <div style={{maxWidth:600, margin:"0 auto", padding:"clamp(24px, 5vw, 48px) clamp(16px, 4vw, 24px)", fontFamily:"'Syne', sans-serif"}}>
      <div style={{marginBottom:28}}>
        <div style={{fontSize:"clamp(20px, 5vw, 26px)", fontWeight:800, letterSpacing:"-0.5px", marginBottom:6}}>Soporte técnico</div>
        <div style={{fontSize:14, color:"#6b7280"}}>Contactanos por cualquier problema, pregunta o sugerencia.</div>
      </div>

      {/* Tarjetas de contacto */}
      <div style={{display:"flex", flexDirection:"column", gap:12, marginBottom:32}}>

        {/* WhatsApp */}
        <a href={"https://wa.me/" + WHATSAPP + "?text=" + WHATSAPP_MSG} target="_blank" rel="noreferrer"
          style={{background:"#ffffff", border:"1px solid #e0e0e8", borderRadius:12, padding:"clamp(16px, 4vw, 20px)", display:"flex", alignItems:"center", gap:16, textDecoration:"none", color:"#1a1a2e", boxShadow:"0 1px 3px rgba(0,0,0,0.06)", cursor:"pointer"}}>
          <div style={{width:48, height:48, borderRadius:10, background:"#f0fdf4", border:"1px solid #bbf7d0", display:"flex", alignItems:"center", justifyContent:"center", fontSize:24, flexShrink:0}}>💬</div>
          <div style={{flex:1}}>
            <div style={{fontSize:16, fontWeight:700, marginBottom:3}}>WhatsApp</div>
            <div style={{fontSize:13, color:"#6b7280"}}>Respuesta rápida en horario de oficina</div>
          </div>
          <div style={{color:"#25D366", fontSize:14, fontWeight:700}}>Escribir →</div>
        </a>

        {/* Email */}
        <a href={"mailto:" + MAIL + "?subject=Soporte FAIM OBRAS"}
          style={{background:"#ffffff", border:"1px solid #e0e0e8", borderRadius:12, padding:"clamp(16px, 4vw, 20px)", display:"flex", alignItems:"center", gap:16, textDecoration:"none", color:"#1a1a2e", boxShadow:"0 1px 3px rgba(0,0,0,0.06)", cursor:"pointer"}}>
          <div style={{width:48, height:48, borderRadius:10, background:"#eff6ff", border:"1px solid #bfdbfe", display:"flex", alignItems:"center", justifyContent:"center", fontSize:24, flexShrink:0}}>✉️</div>
          <div style={{flex:1}}>
            <div style={{fontSize:16, fontWeight:700, marginBottom:3}}>Email</div>
            <div style={{fontSize:13, color:"#6b7280"}}>{MAIL}</div>
          </div>
          <div style={{color:"#3b82f6", fontSize:14, fontWeight:700}}>Enviar →</div>
        </a>
      </div>

      {/* Info */}
      <div style={{background:"#f8f9fa", border:"1px solid #e0e0e8", borderRadius:12, padding:"clamp(14px, 3vw, 20px)"}}>
        <div style={{fontSize:13, fontWeight:700, marginBottom:12, color:"#1a1a2e"}}>Preguntas frecuentes</div>
        {[
          ["¿Cómo agrego un presupuesto?", "Desde el Cotizador → botón '+ Nuevo presupuesto'."],
          ["¿Cómo actualizo precios del catálogo?", "Desde Cotizador → Materiales, Mano de obra o Maquinaria."],
          ["¿Cómo agrego usuarios al estudio?", "Desde Configuración → Usuarios del estudio."],
          ["¿Cómo accede mi cliente al portal?", "Desde Accesos de clientes → Nuevo acceso."],
        ].map(([q, a]) => (
          <div key={q} style={{marginBottom:12, paddingBottom:12, borderBottom:"1px solid #e0e0e8"}}>
            <div style={{fontSize:13, fontWeight:600, marginBottom:3}}>{q}</div>
            <div style={{fontSize:12, color:"#6b7280"}}>{a}</div>
          </div>
        ))}
        <div style={{fontSize:11, color:"#9ca3af", marginTop:4}}>¿No encontrás lo que buscás? Escribinos.</div>
      </div>

      {/* Footer */}
      <div style={{marginTop:32, textAlign:"center", fontSize:11, color:"#9ca3af", fontFamily:"'IBM Plex Mono', monospace", letterSpacing:"0.5px"}}>
        © 2026 FAIM OBRAS · by FIMA Arquitectura · Todos los derechos reservados
      </div>
    </div>
  );
}

// ── Espacio publicitario ──────────────────────────────────────────────────────
// Reemplaza al viejo feed de actividad. Dejá acá tu banner / imagen / promo.
// Para publicar un aviso: poné la URL de la imagen en AD y (opcional) el link.
function EspacioPublicidad() {
  const AD = null;        // ej: { img: "https://...", href: "https://...", alt: "Promo" }

  if (AD && AD.img) {
    const img = <img src={AD.img} alt={AD.alt || "Publicidad"} style={{ width: "100%", borderRadius: 12, display: "block" }} />;
    return (
      <div style={{ marginTop: 40 }}>
        {AD.href ? <a href={AD.href} target="_blank" rel="noreferrer">{img}</a> : img}
      </div>
    );
  }

  // Placeholder mientras no haya aviso cargado.
  return (
    <div style={{ marginTop: 40, border: `1px dashed ${C.border}`, borderRadius: 12, padding: "28px 20px", textAlign: "center", background: C.surface }}>
      <div style={{ fontSize: 10, fontWeight: 700, textTransform: "uppercase", letterSpacing: "1.5px", color: "#c4c4d0" }}>Espacio publicitario</div>
    </div>
  );
}

// ── Main app (identical to FIMA) ──────────────────────────────────────────────
function AppInner({user, tenant, onLogout, onTenantUpdate}) {
  const navigate = useNavigate();
  const location = useLocation();
  const isCotizador = location.pathname.startsWith("/cotizador");
  // Configuración es del dueño de la cuenta: ahí viven los datos del estudio,
  // el alta y baja de usuarios y la facturación. El rol `arquitecto` trabaja
  // en las obras pero no entra. Esconder el módulo es la mitad cómoda; la que
  // manda es el candado del backend (get_tenant_admin).
  const esAdmin = (user?.rol || "admin").toLowerCase() === "admin";
  // El admin siempre tiene todo. Para el resto, lo que no esté explícitamente
  // apagado en `permisos` (ver ConfigCuenta → Usuarios) se toma como
  // permitido — es un checklist de excepciones, no una lista para completar.
  const tienePermiso = (clave) => esAdmin || !clave || user?.permisos?.[clave] !== false;
  const tieneAlguno = (claves) => esAdmin || claves.some(c => user?.permisos?.[c] !== false);
  // Si alguien pega la URL directo sin el permiso, lo manda al inicio en vez
  // de renderizar la pantalla: esconder el mosaico no alcanza como candado.
  const rutaSi = (permitido, el) => permitido ? el : <Navigate to="/" replace/>;

  // El tenant demo público no puede pisar el resto de la app — ni el menú
  // principal, ni Clientes, ni Config: solo el circuito guiado del tour (ver
  // DemoTour.jsx). El propio DemoTour ya redirige mientras el tour está
  // activo, pero esa guarda se basa en una bandera de sessionStorage que se
  // borra al llegar al resumen final; esta corre siempre que el tenant sea
  // demo, así que cubre cualquier link suelto (incluso después del resumen).
  useEffect(() => {
    if (!tenant?.es_demo) return;
    const permitido = /^\/cotizador\/(presupuesto\/\d+(\/(curva|materiales|certificado|resumen-demo))?|gantt\/\d+)$/
      .test(location.pathname);
    if (!permitido) {
      const presuId = sessionStorage.getItem("obras_tour_presupuesto_id");
      navigate(presuId ? `/cotizador/presupuesto/${presuId}` : "/demo", { replace: true });
    }
  }, [location.pathname, tenant?.es_demo, navigate]);

  // Con quien saludamos y que ponemos en el circulito. Los subusuarios pueden
  // no tener mail, asi que nada de esto puede salir de `email` a secas: se
  // prueba nombre, despues usuario, despues mail, y si no hay nada igual se
  // dibuja algo. Un email nulo aca dejaba la pantalla entera en blanco, y
  // encima el header va antes del boundary, asi que ni el cartel se veia.
  const comoSeLlama = user?.nombre || user?.usuario || (user?.email || "").split("@")[0] || "Hola";
  const iniciales = (comoSeLlama.trim().slice(0, 2) || "··").toUpperCase();
  const nombreMarca = tenant?.nombre || "FAIM OBRAS";
  const logoUrl = tenant?.logo_url || null;
  const colorAccent = tenant?.color_primario || C.accent;

  // Mensajes internos: se pregunta liviano y seguido para que el numerito del
  // header se sienta al toque, sin necesidad de un socket.
  const [noLeidos, setNoLeidos] = useState(0);
  useEffect(() => {
    let activo = true;
    const pedir = () => api.get("/mensajes/no-leidos")
      .then(r => { if (activo) setNoLeidos(r.data?.no_leidos || 0); })
      .catch(() => {});
    pedir();
    const t = setInterval(pedir, 20000);
    return () => { activo = false; clearInterval(t); };
  }, []);

  const modules = [
    { id:"cotizador", path:"/cotizador", Icon:FileText,      label:"Presupuestos",          desc:"Obras y proyectos: cotizar, certificar y ejecutar",       color:C.accent2, permiso:"presupuestos" },
    { id:"finanzas",  path:"/finanzas",  Icon:TrendingUp,    label:"Control Financiero",    desc:"Ingresos, egresos y distribución semanal",               color:C.accent,  permisoAlguno:["finanzas_ingresos","finanzas_egresos"] },
    { id:"planner",   path:"/planner",   Icon:Calendar,      label:"Planner",               desc:"Tablero de tareas y calendario",                         color:C.warn,    permiso:"planner" },
    { id:"personal",  path:"/personal",  Icon:Users,         label:"Personal",              desc:"Quién vino, cuántos días y cuánto hay que pagarle",      color:C.accent,  permiso:"personal" },
    { id:"panol",     path:"/panol",     Icon:Package,       label:"Pañol y depósito",      desc:"Herramientas, materiales y en qué obra está cada cosa",  color:C.warn,    permiso:"panol" },
    { id:"clientes",  path:"/clientes",  Icon:Users,         label:"Clientes",              desc:"Clientes, obras y el acceso de cada uno a su portal",    color:C.green,   permiso:"clientes" },
    { id:"mensajes",  path:"/mensajes",  Icon:MessageSquare, label:"Mensajes" + (noLeidos ? ` (${noLeidos})` : ""), desc:"Dejale un aviso a alguien del estudio", color:C.accent2 },
    { id:"config",    path:"/config",    Icon:Settings,      label:"Configuración",         desc:"Logo, nombre y datos del estudio",                       color:C.muted, soloAdmin:true },
    { id:"soporte",   path:"/soporte",   Icon:MessageCircle, label:"Soporte técnico",       desc:"Contacto, ayuda y sugerencias",                          color:C.blue },
  ].filter(m => !m.soloAdmin || esAdmin)
   .filter(m => !m.permiso || tienePermiso(m.permiso))
   .filter(m => !m.permisoAlguno || esAdmin || m.permisoAlguno.some(p => user?.permisos?.[p] !== false));

  // Las pantallas con una barra fija abajo —el presupuesto y su tablero de
  // precios— piden el alto entero de la ventana. Si arriba hay un anuncio o el
  // cartel de la prueba, la suma se pasa y el pie de la página queda abajo del
  // borde: la barra deja de verse. Acá se mide lo que ocupan esos carteles y
  // se publica, para que esas pantallas lo descuenten.
  useEffect(() => {
    const medir = () => {
      let alto = 0;
      document.querySelectorAll(".aviso-arriba").forEach(x => { alto += x.offsetHeight; });
      document.documentElement.style.setProperty("--alto-avisos", alto + "px");
    };
    medir();
    const t = setTimeout(medir, 120);   // por si el cartel entra un instante después
    window.addEventListener("resize", medir);
    return () => { clearTimeout(t); window.removeEventListener("resize", medir); };
  });

  const currentModule = modules.find(m => location.pathname.startsWith(m.path));

  return (
    <div style={{minHeight:"100dvh", background:C.bg, color:C.text, fontFamily:"'Syne', sans-serif"}}>
      <DemoTour />
      {!isCotizador && (
        <div className="header" style={{borderBottom:"1px solid " + C.border, background:C.surface, padding:"0 clamp(16px,4vw,32px)", height:52, display:"flex", alignItems:"center", justifyContent:"space-between"}}>
          <div onClick={()=>navigate("/")} style={{cursor:"pointer", display:"flex", alignItems:"center", gap:8}}>
            {logoUrl
              ? <img src={logoUrl} alt="logo" style={{height:24, objectFit:"contain"}} />
              : <span style={{color:colorAccent, fontWeight:800, fontSize:15, letterSpacing:-0.3}}>{nombreMarca}</span>
            }
            {currentModule && (
              <span style={{fontSize:13, color:C.muted, fontWeight:400}}>/ {currentModule.label}</span>
            )}
          </div>
          <div style={{display:"flex", alignItems:"center", gap:8}}>
            <button onClick={()=>navigate("/mensajes")} aria-label="Mensajes"
              style={{position:"relative", background:"none", border:"none", cursor:"pointer", color:C.muted, padding:4, display:"flex"}}>
              <MessageSquare size={18} strokeWidth={1.5} />
              {noLeidos > 0 && (
                <span style={{position:"absolute", top:0, right:0, background:C.red, color:"#fff", borderRadius:"50%", minWidth:14, height:14, fontSize:9, fontWeight:700, display:"flex", alignItems:"center", justifyContent:"center", fontFamily:"'IBM Plex Mono', monospace", padding:"0 2px"}}>
                  {noLeidos > 9 ? "9+" : noLeidos}
                </span>
              )}
            </button>
            <div style={{width:30, height:30, borderRadius:"50%", background:C.surface2, border:"1px solid " + C.border, display:"flex", alignItems:"center", justifyContent:"center", fontSize:11, fontWeight:700, color:C.muted, fontFamily:"'IBM Plex Mono', monospace"}}>
              {iniciales}
            </div>
            <button onClick={onLogout} style={{fontSize:12, color:C.muted, background:"none", border:"none", cursor:"pointer", fontFamily:"'Syne', sans-serif", display:"flex", alignItems:"center", gap:4, padding:"4px 6px"}}>
              <LogOut size={13} /> Salir
            </button>
          </div>
        </div>
      )}
      {/* La `key` remonta el boundary al cambiar de ruta: sin eso, una pantalla
          que revienta deja el cartel de error puesto para siempre y no se
          puede navegar a ningun otro modulo. */}
      <ErrorBoundary key={location.pathname}>
      <Routes>
        <Route path="/" element={
          <div style={{maxWidth:560, margin:"0 auto", padding:"clamp(40px, 6vw, 64px) clamp(16px, 4vw, 24px)"}}>
            <div style={{marginBottom:"clamp(32px, 5vw, 48px)"}}>
              <div style={{fontSize:"clamp(22px, 5vw, 30px)", fontWeight:800, letterSpacing:"-0.5px", marginBottom:4}}>{comoSeLlama}</div>
              <div style={{fontSize:13, color:C.muted, letterSpacing:"0.2px"}}>¿Con qué vas a trabajar hoy?</div>
            </div>
            <div style={{display:"flex", flexDirection:"column"}}>
              {modules.map((m, i) => (
                <button key={m.id} onClick={()=>navigate(m.path)}
                  style={{background:"none", border:"none", borderTop: i === 0 ? "1px solid " + C.border : "none", borderBottom:"1px solid " + C.border, padding:"clamp(14px,3vw,18px) 0", cursor:"pointer", textAlign:"left", display:"flex", alignItems:"center", gap:14, width:"100%"}}>
                  <m.Icon size={18} strokeWidth={1.5} color={C.text} style={{flexShrink:0}} />
                  <div style={{flex:1, minWidth:0}}>
                    <div style={{fontSize:14, fontWeight:600, color:C.text, marginBottom:2}}>{m.label}</div>
                    <div style={{fontSize:12, color:C.muted, overflow:"hidden", textOverflow:"ellipsis", whiteSpace:"nowrap"}}>{m.desc}</div>
                  </div>
                  <ChevronRight size={15} strokeWidth={1.5} color={C.muted} style={{flexShrink:0}} />
                </button>
              ))}
            </div>
            <EspacioPublicidad />
            <div style={{marginTop:"clamp(40px, 6vw, 56px)", fontSize:11, color:"#c4c4d0", fontFamily:"'IBM Plex Mono', monospace", letterSpacing:"0.5px", textAlign:"center"}}>
              © 2026 FAIM OBRAS · by FIMA Arquitectura
            </div>
          </div>
        }/>
        <Route path="/soporte" element={<PaginaSoporte />}/>
        <Route path="/finanzas/*" element={rutaSi(tieneAlguno(["finanzas_ingresos","finanzas_egresos"]), <ControlFinanciero user={user} />)}/>
        <Route path="/panol" element={rutaSi(tienePermiso("panol"), <Panol />)}/>
        <Route path="/personal" element={rutaSi(tienePermiso("personal"), <Personal />)}/>
        <Route path="/mensajes" element={<Mensajes />}/>
        <Route path="/cotizador" element={rutaSi(tienePermiso("presupuestos"), <Menu />)}/>
        <Route path="/cotizador/presupuesto/:id" element={rutaSi(tienePermiso("presupuestos"), <Presupuesto />)}/>
        <Route path="/cotizador/materiales" element={rutaSi(tienePermiso("presupuestos"), <Materiales />)}/>
        <Route path="/cotizador/mano-obra" element={rutaSi(tienePermiso("presupuestos"), <ManoObra />)}/>
        <Route path="/cotizador/analisis-costos" element={rutaSi(tienePermiso("presupuestos"), <AnalisisCostos />)}/>
        <Route path="/cotizador/presupuesto/:id/certificado" element={rutaSi(tienePermiso("presupuestos"), <Certificado />)}/>
        <Route path="/cotizador/presupuesto/:id/obra" element={rutaSi(tienePermiso("presupuestos"), <Obra user={user} />)}/>
        <Route path="/cotizador/gantt/:id" element={rutaSi(tienePermiso("presupuestos"), <Gantt />)}/>
        <Route path="/cotizador/presupuesto/:id/curva" element={rutaSi(tienePermiso("presupuestos"), <CurvaInversion />)}/>
        <Route path="/cotizador/presupuesto/:id/materiales" element={rutaSi(tienePermiso("presupuestos"), <ListadoMateriales />)}/>
        <Route path="/cotizador/presupuesto/:id/resumen-demo" element={rutaSi(tienePermiso("presupuestos"), <ResumenDemo onRegistrarme={() => {
          sessionStorage.removeItem("obras_tour_demo");
          sessionStorage.removeItem("obras_tour_presupuesto_id");
          sessionStorage.setItem("obras_tour_registro", "1");
          localStorage.removeItem("obras_token");
          localStorage.removeItem("obras_session");
          window.location.href = "/?registro=1";
        }} />)}/>
        <Route path="/cotizador/maquinaria" element={rutaSi(tienePermiso("presupuestos"), <Maquinaria />)}/>
        <Route path="/planner/*" element={rutaSi(tienePermiso("planner"), <Planner user={user} />)}/>
        <Route path="/fiscal/*" element={<Fiscal user={user} />}/>
        <Route path="/clientes/*" element={rutaSi(tienePermiso("clientes"), <Clientes user={user} />)}/>
        <Route path="/accesos-clientes" element={rutaSi(tienePermiso("clientes"), <AccesosClientes user={user} />)}/>
        <Route path="/config" element={esAdmin
          ? <ConfigCuenta user={user} onUpdate={onTenantUpdate} />
          : <div style={{maxWidth:520, margin:"80px auto", padding:24, textAlign:"center", color:C.muted, fontSize:14}}>
              Configuración es solo para el admin del estudio.
            </div>}/>
      </Routes>
      </ErrorBoundary>
      <Asistente />
      <Deshacer />
    </div>
  );
}

// ── Entrada directa a /demo ─────────────────────────────────────────────────
// Link público (ads, WhatsApp, etc.): arranca la demo sola, sin login. En
// pantallas chicas, antes de arrancar, se avisa que conviene verla desde una
// PC (es un sistema de tablas y paneles, no una landing) — con una salida
// real para quien de verdad llegó desde el celular: hablar con el bot de
// WhatsApp en vez de pelear con la demo ahí mismo, o seguir igual si prefiere.
function EntradaDemo({ onEntrar, error }) {
  const [continuar, setContinuar] = useState(() => window.innerWidth > 900);
  useEffect(() => { if (continuar) onEntrar(); }, [continuar]); // eslint-disable-line

  if (!continuar) {
    const msg = encodeURIComponent("Hola! Quería ver la demo de FAIM OBRAS pero estoy en el celular, ¿me ayudás?");
    return (
      <div style={{background:"#f8f9fa",minHeight:"100dvh",display:"flex",flexDirection:"column",alignItems:"center",justifyContent:"center",gap:20,fontFamily:"'Syne',sans-serif",padding:"32px 24px",textAlign:"center"}}>
        <div style={{fontSize:28,fontWeight:800,color:"#059669",letterSpacing:-1}}>FAIM OBRAS</div>
        <div style={{maxWidth:360}}>
          <div style={{fontSize:17,fontWeight:700,color:"#1a1a2e",marginBottom:8}}>Se ve mejor en una computadora</div>
          <div style={{fontSize:13.5,color:"#6b7280",lineHeight:1.55}}>
            Es un sistema de gestión con tablas, paneles y gráficos — en una pantalla grande se entiende mucho mejor de qué se trata. Si tenés una PC a mano, abrí este mismo link ahí.
          </div>
        </div>
        <a href={`https://wa.me/${WHATSAPP_COMPROBANTES}?text=${msg}`} target="_blank" rel="noreferrer"
          style={{display:"flex",alignItems:"center",gap:8,background:"#25D366",color:"#fff",padding:"13px 24px",borderRadius:10,fontWeight:700,fontSize:14,textDecoration:"none",boxShadow:"0 6px 18px rgba(37,211,102,0.3)"}}>
          <MessageCircle size={18} strokeWidth={2.25} /> Escribinos por WhatsApp
        </a>
        <button onClick={() => setContinuar(true)}
          style={{background:"none",border:"none",color:"#6b7280",fontSize:12.5,textDecoration:"underline",cursor:"pointer",padding:4}}>
          Prefiero seguir desde el celular
        </button>
      </div>
    );
  }

  return (
    <div style={{background:"#f8f9fa",height:"100dvh",display:"flex",flexDirection:"column",alignItems:"center",justifyContent:"center",gap:14,fontFamily:"'Syne',sans-serif"}}>
      <div style={{fontSize:32,fontWeight:800,color:"#059669",letterSpacing:-1}}>FAIM OBRAS</div>
      <div style={{fontSize:13,color:"#6b7280"}}>{error || "Preparando tu demo guiada…"}</div>
    </div>
  );
}

export default function App() {
  const [user, setUser] = useState(null);
  const [tenant, setTenant] = useState(null);
  const [loading, setLoading] = useState(true);
  const [suscripcion, setSuscripcion] = useState(null);
  const [clienteInfo, setClienteInfo] = useState(null);
  const [clienteToken, setClienteToken] = useState(null);
  const [estudioInfo, setEstudioInfo] = useState(null);
  const [email, setEmail] = useState("");
  const [pass, setPass] = useState("");
  const [error, setError] = useState("");
  // El campo del estudio no se muestra de entrada: aparece solo si el backend
  // avisa que ese nombre de usuario esta repetido entre estudios.
  const [estudioLogin, setEstudioLogin] = useState("");
  const [pideEstudio, setPideEstudio] = useState(false);
  // El tour del demo manda para acá con ?registro=1 al terminar.
  const [modo, setModo] = useState(() => new URLSearchParams(window.location.search).get("registro") ? "registro" : "login"); // "login" | "registro"
  const [regNombre, setRegNombre] = useState("");
  const [regEstudio, setRegEstudio] = useState("");
  const [regLoading, setRegLoading] = useState(false);
  const [anuncio, setAnuncio] = useState(null);
  const [recienRegistrado, setRecienRegistrado] = useState(false);
  const [reunionAgendada, setReunionAgendada] = useState(false);
  const [demoLoading, setDemoLoading] = useState(false);

  const checkSuscripcion = async () => {
    try {
      const res = await api.get('/suscripcion/estado');
      setSuscripcion(res.data);
    } catch (e) {}
    try {
      const a = await api.get('/anuncio');
      if (a.data && String(localStorage.getItem('anuncio_visto')) !== String(a.data.id)) {
        setAnuncio(a.data);
      }
    } catch (e) {}
  };

  const cerrarAnuncio = () => {
    if (anuncio) localStorage.setItem('anuncio_visto', String(anuncio.id));
    setAnuncio(null);
  };

  useEffect(()=>{
    const restore = async () => {
      // Entrar a /demo tiene que mostrar SIEMPRE el flujo de demo, nunca
      // una sesión real que haya quedado guardada en este navegador (la de
      // quien prueba la demo desde su propia cuenta, por ejemplo): sin este
      // corte, este mismo efecto seguía de largo más abajo, encontraba esa
      // sesión real en localStorage y la restauraba — pisando EntradaDemo
      // (y su cartel de "mejor desde una PC") con el login de siempre,
      // antes de que la persona llegue a verlo.
      if (["/demo", "/demo/"].includes(window.location.pathname)) {
        setLoading(false);
        return;
      }
      // La sesion del tenant demo no tiene que sobrevivir a un refresh (este
      // efecto solo corre una vez al abrir la app — una navegacion normal
      // adentro de React Router no lo vuelve a disparar): ni retomando el
      // presupuesto tal como quedo, ni arrancando una demo nueva sola. Un
      // refresh durante o despues del tour cierra la sesion directamente y
      // deja ver el login, como si nunca hubiese entrado.
      try {
        const s = JSON.parse(localStorage.getItem("obras_session") || "null");
        if (s?.tenant?.es_demo) {
          localStorage.removeItem("obras_token");
          localStorage.removeItem("obras_session");
          localStorage.removeItem("obras_tenant");
          sessionStorage.removeItem("obras_tour_demo");
          sessionStorage.removeItem("obras_tour_presupuesto_id");
          sessionStorage.removeItem("obras_tour_registro");
          if (window.location.pathname !== "/") window.history.replaceState(null, "", "/");
          setLoading(false);
          return;
        }
      } catch {}
      const savedSession = localStorage.getItem("obras_session");
      const savedCliente = localStorage.getItem("obras_cliente");
      const savedEstudio = localStorage.getItem("obras_estudio");
      const token = localStorage.getItem("obras_token");

      if (savedCliente) {
        try {
          const ci = JSON.parse(savedCliente);
          if (ci?.email && ci?.cliente_id) {
            const savedToken = localStorage.getItem("obras_token");
            if (savedToken) setClienteToken(savedToken);
            setClienteInfo(ci); setUser({ email: ci.email, nombre: ci.nombre }); setLoading(false); return;
          }
        } catch { localStorage.removeItem("obras_cliente"); }
      }
      if (savedEstudio) {
        try {
          const ei = JSON.parse(savedEstudio);
          // La condicion pedia mail y dejaba afuera a los subusuarios que
          // entran con usuario: al recargar la pagina los mandaba de vuelta al
          // login. Alcanza con que haya rol y con que se sepa quien es, por
          // mail o por usuario.
          if (ei?.rol && (ei?.email || ei?.usuario || ei?.nombre)) {
            setEstudioInfo(ei);
            setUser({ email: ei.email, nombre: ei.nombre, rol: ei.rol, usuario: ei.usuario });
            const token = localStorage.getItem("obras_token");
            if (token) {
              await checkSuscripcion();
              try {
                const td = (await api.get('/tenant')).data;
                setTenant(td); localStorage.setItem("obras_tenant", JSON.stringify(td));
                // /estudio/login guarda además una copia del tenant en obras_session
                // "por compatibilidad" (tenant.js y otras pantallas la leen primero
                // que obras_tenant). Si acá no se actualiza también, queda pegada a
                // la del día del login y ningún F5 la refresca — un flag nuevo del
                // tenant (como catalogo_separado) nunca llega a aparecer.
                const savedSessRaw = localStorage.getItem('obras_session');
                if (savedSessRaw) {
                  const ns = JSON.parse(savedSessRaw);
                  ns.tenant = td;
                  localStorage.setItem('obras_session', JSON.stringify(ns));
                }
              } catch(e) {}
            }
            setLoading(false); return;
          }
        } catch { localStorage.removeItem("obras_estudio"); }
      }
      if (savedSession && token) {
        try {
          const s = JSON.parse(savedSession);
          if (s?.user && s?.token) {
            setUser(s.user);
            if (s.tenant) setTenant(s.tenant);
            await checkSuscripcion();
            // Refresh tenant data from server to get latest nombre/logo
            try {
              const td = (await api.get('/tenant')).data;
              setTenant(td); localStorage.setItem("obras_tenant", JSON.stringify(td));
              const ns = JSON.parse(localStorage.getItem('obras_session') || '{}');
              ns.tenant = td;
              localStorage.setItem('obras_session', JSON.stringify(ns));
            } catch(e) {}
            setLoading(false);
            return;
          }
        } catch { localStorage.removeItem("obras_session"); }
      }
      setLoading(false);
    };
    restore();
  },[]);

  const login = async () => {
    setError("");
    const emailLower = email.toLowerCase().trim();
    const estudioTxt = estudioLogin.trim();

    // El login prueba varios endpoints hasta que uno contesta, asi que los
    // errores se descartan. Pero el 409 no es un "no sos vos": es el backend
    // diciendo que ese nombre de usuario existe en mas de un estudio y necesita
    // saber cual. Hay que pescarlo antes de que lo tape el intento siguiente.
    let ambiguo = false;
    const intentar = (url, body) => api.post(url, body).catch(e => {
      if (e?.response?.status === 409) ambiguo = true;
      return null;
    });

    try {
      const loginRes = await intentar('/auth/login-cliente', { email: emailLower, password: pass, estudio: estudioTxt });
      if (loginRes) {
        const data = loginRes.data;
        const ci = { cliente_id: data.cliente_id, nombre: data.nombre, email: data.email };
        localStorage.setItem("obras_cliente", JSON.stringify(ci));
        if (data.token) {
          localStorage.setItem("obras_token", data.token);
          setClienteToken(data.token);
        }
        if (data.tenant) {
          setTenant(data.tenant);
          localStorage.setItem("obras_tenant", JSON.stringify(data.tenant));
        }
        setClienteInfo(ci); setUser({ email: data.email, nombre: data.nombre }); return;
      }
    } catch {}

    try {
      const estudioRes = await intentar('/estudio/login', { email: emailLower, password: pass, estudio: estudioTxt });
      if (estudioRes) {
        const data = estudioRes.data;
        const ei = { nombre: data.nombre, rol: data.rol, presupuestos_asignados: data.presupuestos_asignados, email: data.email, usuario: data.usuario, permisos: data.permisos || null };
        localStorage.setItem("obras_estudio", JSON.stringify(ei));
        // Check subscription using the token from estudio login
        if (data.token) {
          localStorage.setItem("obras_token", data.token);
          await checkSuscripcion();
          // Fetch tenant data (also returned by estudio/login now)
          let tenantData = data.tenant || null;
          if (!tenantData) {
            try {
              tenantData = (await api.get('/tenant')).data;
            } catch(e) {}
          }
          if (tenantData) {
            setTenant(tenantData);
            localStorage.setItem("obras_tenant", JSON.stringify(tenantData));
            // Also save in obras_session for compatibility
            localStorage.setItem("obras_session", JSON.stringify({ user: { email: data.email, nombre: data.nombre, rol: data.rol }, tenant: tenantData, token: data.token }));
          }
        }
        setEstudioInfo(ei); setUser({ email: data.email, nombre: data.nombre, rol: data.rol }); return;
      }
    } catch {}

    try {
      const authRes = await intentar('/auth/login', { email: emailLower, password: pass, estudio: estudioTxt });
      if (authRes) {
        const data = authRes.data;
        const token = data.token;
        localStorage.setItem("obras_token", token);
        localStorage.setItem("obras_session", JSON.stringify({ user: data.usuario, tenant: data.tenant, token }));
        setUser(data.usuario);
        if (data.tenant) setTenant(data.tenant);
        await checkSuscripcion();
        return;
      }
    } catch {}

    try {
      const adminRes = await intentar('/admin/login', { email: emailLower, password: pass });
      if (adminRes) {
        localStorage.setItem("obras_admin_token", adminRes.data.token);
        window.location.href = "/admin-panel";
        return;
      }
    } catch {}

    if (ambiguo) {
      setPideEstudio(true);
      setError("Ese usuario existe en más de un estudio. Indicá cuál.");
      return;
    }
    setError("Usuario o contraseña incorrectos");
  };

  const registrar = async () => {
    setError("");
    if (!regEstudio.trim() || !regNombre.trim() || !email.trim() || !pass.trim()) {
      setError("Completá todos los campos"); return;
    }
    setRegLoading(true);
    try {
      const res = await api.post('/auth/register', { nombre_estudio: regEstudio.trim(), nombre_usuario: regNombre.trim(), email: email.toLowerCase().trim(), password: pass });
      const data = res.data;
      if (data) {
        const token = data.token;
        const userData = data.usuario || { email: email.toLowerCase().trim(), nombre: regNombre.trim(), rol: "admin" };
        localStorage.setItem("obras_token", token);
        localStorage.setItem("obras_session", JSON.stringify({ user: userData, tenant: data.tenant, token }));
        if (data.tenant) setTenant(data.tenant);
        await checkSuscripcion();
        // `recienRegistrado` es estado de React: si la persona vuelve de
        // MercadoPago (redirect real, recarga la página) o simplemente
        // refresca antes de pagar, se pierde — y como un tenant nuevo ya
        // nace en estado "vencido" (ver /auth/register), cae derecho al
        // paywall de precio completo sin volver a ver la promo nunca más.
        // Esto lo persiste unas horas para que sobreviva esa vuelta.
        localStorage.setItem("obras_promo_hasta", String(Date.now() + 1000 * 60 * 60 * 48));
        setRecienRegistrado(true);
        setUser(userData);
      } else {
        setError(data.detail || "Error al registrarse");
      }
    } catch { setError("Error de conexión"); }
    setRegLoading(false);
  };

  // Tour guiado público: entra directo al tenant demo (sin registro) y marca
  // la bandera que arranca el tour apenas carga la app.
  const entrarDemo = async () => {
    setError(""); setDemoLoading(true);
    try {
      const res = await api.post('/demo/entrar');
      const data = res.data;
      const token = data.token;
      localStorage.setItem("obras_token", token);
      localStorage.setItem("obras_session", JSON.stringify({ user: data.usuario, tenant: data.tenant, token }));
      sessionStorage.setItem("obras_tour_demo", "1");
      if (data.presupuesto_id) sessionStorage.setItem("obras_tour_presupuesto_id", String(data.presupuesto_id));
      if (data.tenant) setTenant(data.tenant);
      await checkSuscripcion();
      // Si se entró por /demo, dejar la URL en "/" para que el router normal
      // (y el tour) tomen desde ahí.
      if (window.location.pathname.startsWith("/demo")) window.history.replaceState(null, "", "/");
      setUser(data.usuario);
    } catch { setError("No se pudo iniciar la demo. Probá de nuevo."); }
    setDemoLoading(false);
  };

  const handleLogout = () => {
    localStorage.removeItem("obras_token");
    localStorage.removeItem("obras_session");
    localStorage.removeItem("obras_cliente");
    localStorage.removeItem("obras_estudio");
    sessionStorage.removeItem("susc_reload");
    sessionStorage.removeItem("obras_tour_demo");
    setUser(null); setClienteInfo(null); setEstudioInfo(null); setSuscripcion(null); setTenant(null);
  };

  // Link directo a la demo guiada (lo que se comparte en ads/WhatsApp): entra
  // sola, sin pasar por el botón del login.
  if (!user && ["/demo", "/demo/"].includes(window.location.pathname)) {
    return <EntradaDemo onEntrar={entrarDemo} error={error} />;
  }

  // Super admin panel — rutas directas
  if (window.location.pathname === "/admin-panel" || window.location.pathname === "/admin") {
    return <AdminSuperPanel />;
  }

  // Chat del bot de WhatsApp — página propia (antes era una pestaña del admin).
  // faimobras.online es un dominio aparte, dedicado solo a esto: ahí se muestra
  // sin importar la ruta (así entrar a la raíz ya cae directo en el bot, sin
  // pasar por la pantalla de login/registro de FAIM OBRAS).
  const esDominioBot = window.location.hostname === "faimobras.online" || window.location.hostname === "www.faimobras.online";
  if (esDominioBot || window.location.pathname === "/bot" || window.location.pathname === "/bot-chat") {
    return <BotChatPanel />;
  }

  // Presentación comercial — pública, sin login. Es el link que se le manda a
  // un prospecto. Va antes del chequeo de sesión para que abra directo.
  if (window.location.pathname === "/presentacion" || window.location.pathname === "/presentacion/") {
    return <Presentacion />;
  }

  // Demo del portal de clientes — también pública. Muestra con datos ficticios
  // lo que ve el cliente del estudio, sin pedir usuario.
  if (["/demo-portal", "/demo-portal/", "/portal-demo", "/portal-demo/"].includes(window.location.pathname)) {
    return <DemoPortal />;
  }

  if (loading) return (
    <div style={{background:"#f8f9fa",height:"100dvh",display:"flex",alignItems:"center",justifyContent:"center",color:"#059669",fontFamily:"'Syne',sans-serif",fontSize:32,fontWeight:800}}>
      FAIM OBRAS
    </div>
  );

  // Login / Registro screen
  // Show landing if accessing root without being logged in
  if (!user && window.location.pathname === '/landing') return <BrowserRouter><Landing /></BrowserRouter>;
  if (!user) return (
    <div style={{background:"#f8f9fa",height:"100dvh",display:"flex",alignItems:"center",justifyContent:"center",padding:24,fontFamily:"'Syne',sans-serif"}}>
      <div style={{width:"100%",maxWidth:360}}>
        <style>{`@keyframes faimDemoGlow { 0%,100% { box-shadow: 0 8px 24px rgba(5,150,105,0.35), 0 0 0 0 rgba(5,150,105,0.4); } 50% { box-shadow: 0 8px 28px rgba(5,150,105,0.45), 0 0 0 8px rgba(5,150,105,0); } }`}</style>
        <div style={{fontSize:42,fontWeight:800,color:"#059669",letterSpacing:"-1px",marginBottom:4}}>FAIM OBRAS</div>
        <div style={{fontSize:12,color:"#6b7280",marginBottom:20,fontFamily:"'IBM Plex Mono',monospace",letterSpacing:"2px"}}>GESTIÓN PARA ESTUDIOS Y EMPRESAS</div>

        {/* CTA de la demo: el camino de menor fricción, así que va primero y
            bien visible — no un link chiquito abajo del login. */}
        <button onClick={entrarDemo} disabled={demoLoading} style={{width:"100%",padding:"16px",marginBottom:10,borderRadius:14,border:"none",cursor:"pointer",background:"linear-gradient(135deg, #059669 0%, #047857 100%)",color:"#fff",fontFamily:"'Syne',sans-serif",fontWeight:800,fontSize:15.5,display:"flex",alignItems:"center",justifyContent:"center",gap:9,opacity:demoLoading?0.75:1,animation:demoLoading?"none":"faimDemoGlow 2.2s ease-in-out infinite"}}>
          <PlayCircle size={20} strokeWidth={2.25} />
          {demoLoading ? "Entrando a la demo..." : "Probar la demo guiada"}
        </button>
        <div style={{textAlign:"center",fontSize:11.5,color:"#9ca3af",marginBottom:22}}>Sin registrarte · con datos de ejemplo · 5 minutos</div>

        {/* Tabs */}
        <div style={{display:"flex",gap:4,marginBottom:24,background:"#f1f3f5",borderRadius:8,padding:4}}>
          <button onClick={()=>{setModo("login");setError("");}} style={{flex:1,padding:"8px",borderRadius:6,border:"none",cursor:"pointer",fontFamily:"'Syne',sans-serif",fontWeight:600,fontSize:13,background:modo==="login"?"#fff":"transparent",color:modo==="login"?"#1a1a2e":"#6b7280",boxShadow:modo==="login"?"0 1px 3px rgba(0,0,0,0.1)":"none"}}>Ingresar</button>
          <button onClick={()=>{setModo("registro");setError("");}} style={{flex:1,padding:"8px",borderRadius:6,border:"none",cursor:"pointer",fontFamily:"'Syne',sans-serif",fontWeight:600,fontSize:13,background:modo==="registro"?"#fff":"transparent",color:modo==="registro"?"#1a1a2e":"#6b7280",boxShadow:modo==="registro"?"0 1px 3px rgba(0,0,0,0.1)":"none"}}>Registrarme</button>
        </div>

        {modo === "login" ? (
          <>
            {/* Un solo campo para las dos cosas: el dueño del estudio entra con
                su mail y la gente que él da de alta con el usuario que le puso.
                No hace falta que elijan de antemano cuál es cuál. */}
            <div style={{marginBottom:14}}>
              <label style={{display:"block",fontSize:11,color:"#6b7280",marginBottom:6,fontWeight:600,letterSpacing:"1px",textTransform:"uppercase"}}>Usuario o email</label>
              <input value={email} onChange={e=>setEmail(e.target.value)} type="text" autoCapitalize="none" autoCorrect="off" className="input" style={{width:"100%",boxSizing:"border-box"}}/>
            </div>
            {/* Solo cuando el mismo usuario existe en más de un estudio. */}
            {pideEstudio && (
              <div style={{marginBottom:14}}>
                <label style={{display:"block",fontSize:11,color:"#6b7280",marginBottom:6,fontWeight:600,letterSpacing:"1px",textTransform:"uppercase"}}>Estudio</label>
                <input value={estudioLogin} onChange={e=>setEstudioLogin(e.target.value)} type="text" autoCapitalize="none" autoCorrect="off" className="input" style={{width:"100%",boxSizing:"border-box"}} placeholder="Nombre del estudio"/>
              </div>
            )}
            <div style={{marginBottom:14}}>
              <label style={{display:"block",fontSize:11,color:"#6b7280",marginBottom:6,fontWeight:600,letterSpacing:"1px",textTransform:"uppercase"}}>Contraseña</label>
              <input value={pass} onChange={e=>setPass(e.target.value)} type="password" className="input" style={{width:"100%",boxSizing:"border-box"}} onKeyDown={e=>e.key==="Enter"&&login()}/>
            </div>
            {error&&<div style={{fontSize:13,color:"#f87171",marginBottom:12,textAlign:"center"}}>{error}</div>}
            <button onClick={login} className="btn btn-primary" style={{width:"100%",padding:"12px",marginTop:8,fontSize:15,justifyContent:"center"}}>Ingresar</button>
          </>
        ) : (
          <>
            <div style={{marginBottom:14}}>
              <label style={{display:"block",fontSize:11,color:"#6b7280",marginBottom:6,fontWeight:600,letterSpacing:"1px",textTransform:"uppercase"}}>Nombre del estudio o empresa</label>
              <input data-tour="reg-estudio" value={regEstudio} onChange={e=>setRegEstudio(e.target.value)} type="text" className="input" style={{width:"100%",boxSizing:"border-box"}} placeholder="Ej: MRA+Asociados"/>
            </div>
            <div style={{marginBottom:14}}>
              <label style={{display:"block",fontSize:11,color:"#6b7280",marginBottom:6,fontWeight:600,letterSpacing:"1px",textTransform:"uppercase"}}>Tu nombre</label>
              <input data-tour="reg-nombre" value={regNombre} onChange={e=>setRegNombre(e.target.value)} type="text" className="input" style={{width:"100%",boxSizing:"border-box"}} placeholder="Ej: Matias"/>
            </div>
            <div style={{marginBottom:14}}>
              <label style={{display:"block",fontSize:11,color:"#6b7280",marginBottom:6,fontWeight:600,letterSpacing:"1px",textTransform:"uppercase"}}>Email</label>
              <input data-tour="reg-email" value={email} onChange={e=>setEmail(e.target.value)} type="email" className="input" style={{width:"100%",boxSizing:"border-box"}}/>
            </div>
            <div style={{marginBottom:14}}>
              <label style={{display:"block",fontSize:11,color:"#6b7280",marginBottom:6,fontWeight:600,letterSpacing:"1px",textTransform:"uppercase"}}>Contraseña</label>
              <input data-tour="reg-pass" value={pass} onChange={e=>setPass(e.target.value)} type="password" className="input" style={{width:"100%",boxSizing:"border-box"}} onKeyDown={e=>e.key==="Enter"&&registrar()}/>
            </div>
            {error&&<div style={{fontSize:13,color:"#f87171",marginBottom:12,textAlign:"center"}}>{error}</div>}
            <button data-tour="reg-crear" onClick={registrar} disabled={regLoading} className="btn btn-primary" style={{width:"100%",padding:"12px",marginTop:8,fontSize:15,justifyContent:"center",opacity:regLoading?0.7:1}}>
              {regLoading ? "Creando cuenta..." : "Crear cuenta y suscribirme"}
            </button>
            <RegistroTour />
          </>
        )}
      </div>
    </div>
  );

  // Pantalla comercial post-registro: va ANTES que el paywall de trial
  // vencido — si no, un tenant nuevo (que ya nace "vencido", sin trial) cae
  // directo en la pantalla de precio completo y nunca ve la promo.
  //
  // `recienRegistrado` es estado de React y no sobrevive una vuelta real de
  // MercadoPago (redirect) ni un refresh antes de pagar — por eso también
  // se respeta `obras_promo_hasta` en localStorage, una ventana de 48hs
  // desde el registro para que la promo no se pierda por eso. Se limpia
  // sola una vez que el estudio ya pagó (plan_estado activo).
  let promoVigente = false;
  try {
    const hasta = parseInt(localStorage.getItem("obras_promo_hasta") || "0", 10);
    promoVigente = hasta > Date.now();
    if (tenant?.plan_estado === "activo" && hasta) localStorage.removeItem("obras_promo_hasta");
  } catch {}

  if (recienRegistrado || (promoVigente && user && suscripcion && suscripcion.trial_vencido)) {
    return <PantallaVentaPostRegistro tenant={tenant} token={localStorage.getItem("obras_token")} onContinuar={() => setRecienRegistrado(false)} onLogout={handleLogout} />;
  }

  // Subscription wall — only for JWT users
  if (user && suscripcion && suscripcion.trial_vencido) {
    return <SuscripcionVencida suscripcion={suscripcion} onLogout={handleLogout} />;
  }

  // Trial banner wrapper. El aviso de agendar reunión va pegado cuando ya
  // pagó y todavía no eligió horario — no hay reuniones previas al pago.
  const mostrarAvisoReunion = tenant?.plan_estado === "activo" && !tenant?.reunion_slot && !reunionAgendada && !tenant?.es_demo;
  const banner = (suscripcion && suscripcion.en_trial ? <TrialBanner diasRestantes={suscripcion.dias_restantes} /> : null) ||
    (mostrarAvisoReunion ? <AvisoAgendarReunion token={localStorage.getItem("obras_token")} onAgendada={() => setReunionAgendada(true)} /> : null);

  // Los dos portales van envueltos igual que el resto. Cuando el boundary
  // cubria solo las rutas de adentro, un error en el portal del personal
  // seguia dando pantalla en blanco sin ningun mensaje — que es exactamente
  // como se manifesto el bug de presupuestos_asignados.
  if (clienteInfo) {
    return (
      <ErrorBoundary>
        <ClientePortal user={user} clienteId={clienteInfo.cliente_id} clienteNombre={clienteInfo.nombre} onLogout={handleLogout} token={clienteToken || localStorage.getItem("obras_token")} />
      </ErrorBoundary>
    );
  }

  if (estudioInfo) {
    if (estudioInfo.rol === "personal") {
      return (
        <ErrorBoundary>
          <PersonalPortal user={user} userInfo={estudioInfo} onLogout={handleLogout} />
        </ErrorBoundary>
      );
    }
    return (
      <BrowserRouter>
        <AnuncioBanner anuncio={anuncio} onClose={cerrarAnuncio} />
        {banner}
        <ErrorBoundary>
          <AppInner user={{ ...user, rol: estudioInfo.rol, nombre: estudioInfo.nombre, usuario: estudioInfo.usuario }} tenant={tenant} onLogout={handleLogout} onTenantUpdate={(data) => setTenant(t => ({...t, ...data}))} />
        </ErrorBoundary>
      </BrowserRouter>
    );
  }

  return (
    <BrowserRouter>
      <AnuncioBanner anuncio={anuncio} onClose={cerrarAnuncio} />
      {banner}
      <ErrorBoundary>
        <AppInner user={user} tenant={tenant} onLogout={handleLogout} onTenantUpdate={(data) => setTenant(t => ({...t, ...data}))} />
      </ErrorBoundary>
      {/* El aviso de versión nueva está apagado a pedido: aparecía en la
          pantalla de todos los estudios cada vez que se publica algo.
          El componente sigue en components/AvisoVersion.jsx y se vuelve a
          prender descomentando esta línea — no se borró nada.

          Lo que resuelve, por si hace falta volver a evaluarlo: el navegador
          que ya tenía la aplicación abierta sigue con la versión vieja hasta
          que alguien recarga a mano, y eso termina en "no me aparece lo
          nuevo" y en un rato buscando un problema que no existe. */}
      {/* <AvisoVersion /> */}
    </BrowserRouter>
  );
}
